const key = 'lsa-affiliate-referral'
const lifetime = 60 * 24 * 60 * 60 * 1000

export function captureAffiliateReferral() {
  try {
    const token = new URLSearchParams(window.location.search).get('fpr')
    if (token && /^[a-zA-Z0-9_-]{1,160}$/.test(token)) {
      try { localStorage.setItem(key, JSON.stringify({ token, expires: Date.now() + lifetime })) } catch (e) { /* Direct links still work without storage. */ }
      return token
    }
  } catch (e) { /* Browser privacy settings may disable storage. */ }
  return null
}

export function affiliateReferral() {
  const current = captureAffiliateReferral()
  if (current) return current
  try {
    const saved = JSON.parse(localStorage.getItem(key) || 'null')
    if (saved && saved.expires > Date.now() && /^[a-zA-Z0-9_-]{1,160}$/.test(saved.token)) return saved.token
    localStorage.removeItem(key)
  } catch (e) { /* Direct referral links still work without persistent storage. */ }
  return null
}

export function clearAffiliateReferral() {
  try { localStorage.removeItem(key) } catch (e) { /* Optional storage. */ }
}
